export default __webpack_public_path__ + "static/media/all-cats.d90bd987.webp";